module.exports = __webpack_public_path__ + "media/images/flags/32/Iraq-db57d1d57af442540a2e6ac204c4faac.png";